import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { Shortlist } from 'types/shortlist'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { updateShortlist } from '@disco/state-management/actions/ShortlistActions'
import { getShortlistById } from '@disco/state-management/selectors/shortlists'
import { pick } from '@disco/utils/array'
import HTMLEditor from 'components/ui/html-editor'
type Props = {
  params: {
    shortlistId: string
  }
}

const PlaylistMessageEdit = ({
  params: { shortlistId },
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const shortlist: Shortlist | null | undefined = useSelector(state =>
    getShortlistById(state, {
      id: shortlistId,
    }),
  )
  const [state, setState] = useState<Partial<Shortlist>>(
    pick(shortlist, ['general_message', 'general_message_html']),
  )
  useEffect(() => {
    setState(pick(shortlist, ['general_message', 'general_message_html']))
  }, [shortlist])

  const handleBlur = () => {
    if (state.general_message_html !== shortlist?.general_message_html) {
      dispatch(sendMixpanelEvent('Default playlist - Update playlist message'))
      dispatch(updateShortlist(shortlistId, state))
    }
  }

  const handleChange = useCallback(
    (general_message, general_message_html) => {
      setState(state => ({ ...state, general_message, general_message_html }))
    },
    [dispatch],
  )
  return (
    <HTMLEditor
      initialContent={state.general_message}
      label="Add Playlist Message"
      onBlur={handleBlur}
      onChange={handleChange}
    />
  )
}

export default PlaylistMessageEdit
